import { useOrganization } from '@clerk/nextjs';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useRouter } from 'next/router';

export interface UpdateCountriesResponse {
  data: {
    success: boolean;
  };
}

type UpdateCountriesParams = {
  orgDefaultCountries?: AvailableCountries[];
  userDefaultCountries: AvailableCountries[];
};

export const useUpdateCountries = () => {
  const router = useRouter();
  const { organization } = useOrganization();

  const orgId = organization?.id;

  return useMutation<UpdateCountriesResponse, Error, UpdateCountriesParams>({
    mutationFn: async ({ orgDefaultCountries, userDefaultCountries }) => {
      // Filter out undefined values to prevent null/undefined in API
      const filteredUserCountries = (userDefaultCountries || []).filter((country) => country !== undefined);

      const endpoint = `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/customer/${orgId}/update-country`;

      const requestBody: UpdateCountriesParams = {
        userDefaultCountries: filteredUserCountries,
      };

      // Only include orgDefaultCountries if provided (admin users only)
      if (orgDefaultCountries !== undefined) {
        const filteredCountries = (orgDefaultCountries || []).filter((country) => country !== undefined);
        requestBody.orgDefaultCountries = filteredCountries;
      }

      return axios.put(endpoint, requestBody);
    },
    onSuccess: () => {
      // refresh the page using Next.js router
      router.reload();
    },
    onError: (error) => {
      console.error('Error updating countries:', error);
    },
  });
};
